import { useMediaQuery } from "react-responsive";
import { Text } from "../../../../../../library/text";
import { Title } from "../../../../../../library/title";
import {
  Container,
  ContentWrapper,
  DisplayRow,
  InputWrapper,
  TextWrapper,
  UpperContainer,
  UpperTextWrapper,
} from "./styled";
import TranscriptionNotification from "./transcription-notification";
import { MOBILE_VIEW } from "../../../../../../variables";
import RenderingNotification from "./rendering-notification";

const UserNotifications = () => {
  const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE_VIEW}px)` });

  const OPTIONS = [
    {
      title: "Transkribering",
      description: "Oppdater varsler for ferdige transkriberinger",
      display: <TranscriptionNotification />,
    },
    {
      title: "Videorendring",
      description: "Oppdater varsler for ferdige videorendringer",
      display: <RenderingNotification />,
    },
  ];

  return (
    <Container>
      <UpperContainer>
        <UpperTextWrapper>
          <Title size="sm">Varslinger</Title>
          <Text size="small" color="dark">
            Velg om du vil motta varslinger når en transkribering eller video er
            ferdig.
          </Text>
        </UpperTextWrapper>
      </UpperContainer>
      <ContentWrapper>
        {OPTIONS.map((option, index) => (
          <DisplayRow key={index}>
            <TextWrapper>
              <Title size="xxs">{option.title}</Title>
              {!isMobile && (
                <Text size="small" color="dark">
                  {option.description}
                </Text>
              )}
            </TextWrapper>
            <InputWrapper>{option.display}</InputWrapper>
          </DisplayRow>
        ))}
      </ContentWrapper>
    </Container>
  );
};

export default UserNotifications;
